<ng-template #messageTmpl>
 <ng-container [ngSwitch]="data.id">

        <div *ngSwitchCase="'interestssyncing'" class="app-alert alert alert-info" i18n="interests syncing@@interests-syncing">Syncronizing...</div>

        <div *ngSwitchCase="'interestsselectionupdated'" class="app-alert alert alert-success" i18n="interests updated@@interests-updated">Your interests has been updated</div>

        <div *ngSwitchCase="'interestsselectionsynced'" class="app-alert alert alert-success" i18n="interests synced@@interests-synced">Your interests has been syncronized with your profile</div>

        <div *ngSwitchCase="'languageselectionupdated'" class="app-alert alert alert-success" i18n="languages updated@@languages-updated">Your languages has been updated</div>

        <div *ngSwitchCase="'updatedorder'" class="app-alert alert alert-success" i18n="updated order@@updated-order">Sorting has been updated</div>

        <div *ngSwitchCase="'newssettingsupdated'" class="app-alert alert alert-success" i18n="news settings updated@@news-settings-updated">News settings has been updated</div>

        <div *ngSwitchCase="'tabconfigupdated'" class="app-alert alert alert-success" i18n="tab config updated@@tab-config-updated">Your board settings has been updated</div>

        <div *ngSwitchCase="'channelcachecleared'" class="app-alert alert alert-success" i18n="channel cache cleared@@channel-cache-cleared">Channel cache was cleared</div>

        <div *ngSwitchCase="'operationcompleted'" class="app-alert alert alert-success" i18n="operation completed@@operation-completed">Operation was completed</div>

        <div *ngSwitchCase="'updatedsetting'" class="app-alert alert alert-success" i18n="updated setting@@updated-setting">Updated setting</div>

        <div *ngSwitchCase="'genericupdated'" class="app-alert alert alert-success" i18n="@@updated-alert">Updated!</div>

        <div *ngSwitchCase="'genericadded'" class="app-alert alert alert-success" i18n="@@added-alert">Added!</div>

        <div *ngSwitchCase="'genericdeleted'" class="app-alert alert alert-success" i18n="@@deleted-alert">Deleted!</div>

        <div *ngSwitchCase="'offline'" class="app-alert alert alert-warning" i18n="@@no-internet-alert">No internet - Only locally saved data available</div>

        <div *ngSwitchCase="'unlicensed'" class="app-alert alert alert-warning" i18n="@@unlicensed-alert">You are not licensed to view the requested page</div>

        <div *ngSwitchDefault class="app-alert alert alert-danger">{{data}}</div>
    </ng-container>

</ng-template>

<ng-container *ngIf="isNumber(data);else messageTmpl">
    <div class="app-alert alert alert-danger">
        <app-error-templates [error]="errorCode" [errorInfo]="errorInfo" [componentName]="componentName"></app-error-templates>
    </div>
</ng-container>


<ng-container *ngIf="false">
    <!--ONLY USED TO GENERATE TRANSLATEABLE STRINGS THAT WE CAN FETCH AND USE IN CODE-->
    <span i18n="@@click-to-sign-in">Click to Sign in</span>
    <span i18n="@@allow-popups">You can skip this step by allowing popups for this site in your browser (see below).</span>
</ng-container>
